import { render, staticRenderFns } from "./CustomerTaskList.vue?vue&type=template&id=37d99bdd"
import script from "./CustomerTaskList.vue?vue&type=script&lang=ts"
export * from "./CustomerTaskList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports